import styled from 'styled-components'

export const SelectWrapper = styled.div`
  .ant-select.ant-select-in-form-item {
    border: 1px solid #d9d9d9 !important;
  }
`
